import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4f600d1c"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "live-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "line move1"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "line move2"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "line move3"
})], -1));

const _hoisted_2 = [_hoisted_1];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, _hoisted_2);
}